var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.item.descr))]),_c('td',[_c('memlist-select-input2',{attrs:{"items":_vm.templateOptions},on:{"input":_vm.templateRowUpdated},model:{value:(_vm.local_item.template_id),callback:function ($$v) {_vm.$set(_vm.local_item, "template_id", $$v)},expression:"local_item.template_id"}})],1),_c('td')])
}
var staticRenderFns = []

export { render, staticRenderFns }